/* eslint-disable @typescript-eslint/no-explicit-any */
import {AxiosError, AxiosResponse} from 'axios';
import {deepRemoveNil, toCamelCase} from 'utils/object';

import ApiError from './classes/error/api-error';
import ApiSuccess from './classes/success/api-success';
import DuckTypeMatchResponse, {
    DuckTypeMatchResponseReturnType,
} from './duck-type-match';

export const handleRedirect = (response: AxiosResponse) => {
    const {host, protocol} = window.location;
    const base = `${protocol}//${host}`;
    const initialUrl = new URL(response.config.url || '', base);
    const returnedUrl = new URL(response.request.responseURL || '', base);

    if (initialUrl.href !== returnedUrl.href) {
        window.location.href = returnedUrl.href;

        return true;
    }

    return false;
};

const ResponseValidator = async (response: AxiosResponse) => {
    if (handleRedirect(response)) {
        return;
    }

    const {data, request, status} = response;
    const {responseType} = request;
    let json: any;
    let jsonParseFailed = false;
    const isBinary = ['arraybuffer', 'blob', 'stream'].includes(responseType);

    if (isBinary) {
        return new ApiSuccess({
            data,
            status,
        });
    }

    try {
        json = data;
        json = deepRemoveNil(toCamelCase(json));
    } catch {
        jsonParseFailed = true;
        json = undefined;
    }

    // Process all non-success requests
    if (status >= 400) {
        if (jsonParseFailed) {
            return new ApiError({
                data: undefined,
                message: 'Unable to parse response',
                status,
            });
        }

        const parameters = DuckTypeMatchResponse({
            json,
            status,
        });

        return new ApiError(parameters);
    }

    return new ApiSuccess({
        data:
            json?.status === 'OK' && json?.result
                ? json?.result
                : json?.response,
        status,
    });
};

export const ErrorValidator = (error: AxiosError) => {
    const {response} = error;
    const status = response ? response.status : 404;

    let json: any;
    let parameters: DuckTypeMatchResponseReturnType | undefined;

    try {
        json = response?.data;
        json = deepRemoveNil(toCamelCase(json));
        parameters = DuckTypeMatchResponse({
            json,
            status: status || 404,
        });
    } catch {
        json = undefined;
    }

    if (parameters) {
        return new ApiError(parameters);
    }

    return new ApiError({
        data: undefined,
        message: 'Unable to parse response',
        status: status || 404,
    });
};

export default ResponseValidator;
